<template>
  <router-view/>
</template>
<style lang="scss" scoped>
@import "./assets/reset.css";
</style>
